import { FC, SVGProps } from 'react'

export const Sleeping: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M6.91989 9.64831C7.32853 9.71607 7.60486 10.1023 7.5371 10.5109C7.46934 10.9195 7.08315 11.1959 6.67452 11.1281L2.8264 10.49C2.41777 10.4223 2.14143 10.0361 2.20919 9.62743C2.27695 9.21879 2.66315 8.94246 3.07178 9.01022L6.91989 9.64831ZM15.5927 11.9308C15.5118 11.9308 15.4315 11.9439 15.3548 11.9695L10.5742 13.5682L0.853544 12.2145C0.44329 12.1573 0.064396 12.4436 0.00726128 12.8539C-0.0498734 13.2641 0.236387 13.643 0.646641 13.7001L10.5417 15.0782C10.6563 15.0942 10.7732 15.0834 10.883 15.0466L15.7148 13.4308H22.752C23.1663 13.4308 23.502 13.095 23.502 12.6808C23.502 12.2666 23.1663 11.9308 22.752 11.9308H15.5927Z"
			fill="currentColor"
		/>
	</svg>
)
